import { createFileRoute, redirect } from '@tanstack/react-router'
import { WalkdownDetails } from 'pages/walkdown/WalkdownDetails'
import { walkdownDetailsSearchParams } from 'routes/walkdowns/-searchParams'

const RouteComponent = () => {
  const { siteId, walkdownId } = Route.useSearch()

  return <WalkdownDetails siteId={siteId} walkdownId={walkdownId} />
}

export const Route = createFileRoute('/walkdowns/details')({
  component: RouteComponent,
  staticData: {
    title: 'Walkdown Details',
  },
  validateSearch: walkdownDetailsSearchParams,
  beforeLoad: ({ search }) => {
    if (!search.walkdownId) {
      throw redirect({
        to: '/walkdowns',
        search: { siteId: search.siteId },
      })
    }
  },
})
